// Custom scripts
import PopupUsunieciePozycjiZKoszyka from "./popup-usuniecie-pozycji-z-koszyka";
import PopupPustyKoszyk from "./popup-pusty-koszyk";
import Koszyk from "./koszyk";
import PopupZaloguj from "./popup-zaloguj";

(() => {
  if (typeof $ === "undefined") {
    throw new TypeError("... requires jQuery.");
  }

  $(document).ready(() => {
    const popupUsunieciePozycjiZKoszyka = new PopupUsunieciePozycjiZKoszyka();
    const popupPustyKoszyk = new PopupPustyKoszyk();
    const koszyk = new Koszyk();
    const popupZaloguj = new PopupZaloguj();

    popupUsunieciePozycjiZKoszyka.init();
    popupPustyKoszyk.init();
    koszyk.init();
    popupZaloguj.init();
  });
})();
